import React from 'react';
import SharedButton from '../../shared/buttons/shared-button';

import { useTheme, type SxProps, type Theme } from '@mui/material/styles';
import PlayArrow from '@mui/icons-material/PlayArrow';

interface RunPolicyButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
}

export default function RunPolicyButton({
  onClick,
  disabled = false,
}: Readonly<RunPolicyButtonProps>) {
  const theme = useTheme();

  const sx: SxProps<Theme> = {
    height: 28,
    width: 115,
    fontSize: '0.75rem',
    fontWeight: 500,
    borderColor: theme.palette.semantic.button.secondary.border,
    color: theme.palette.semantic.button.secondary.border,
    ':hover': {
      borderColor: theme.palette.semantic.hyperlink.active,
      color: theme.palette.semantic.hyperlink.active,
    },
    '&.Mui-disabled': {
      borderColor: theme.palette.semantic.hyperlink.disabled,
      color: theme.palette.semantic.hyperlink.disabled,
    },
  };

  return (
    <SharedButton
      variant="secondary"
      size="small"
      color="primary"
      disabled={disabled}
      startIcon={<PlayArrow fontSize="small" />}
      onClick={onClick}
      sx={sx}
    >
      Run Policy
    </SharedButton>
  );
}
